export default __webpack_public_path__ + "static/media/booking-app-pic3.0629bff9.png";